import {useContext} from "react";
import {Pagination, Table, Tag} from "antd";
import {
	Image,
	PopperUserInfo,
} from "~/components";
import BuyServiceAction from "./BuyServiceAction";
import {renderDateTime} from "~/utils";
import {AppContext} from "~/context/AppProvider";

function BuyServiceTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const {tableHeight} = useContext(AppContext);

	const renderFor = (ufor) => {

		if(ufor === 'canhan')
		{
			return <Tag color="green">Cá nhân</Tag>
		}
		if(ufor === 'congty')
		{
			return <Tag color="blue">Công ty</Tag>
		}

		return <Tag color="green">Không xác định</Tag>
	}

	const columns = [
		{ title: 'Hợp đồng', dataIndex: 'contract', key: "contract", width: '400px', render: (_, item) => (
			<>
				{(item?.contract?.id) && <p><Tag color="green">{item?.contract.code}</Tag> {item?.contract.name}</p> }
				<p><b>{item.domain}</b></p>
				<p style={{fontSize:'11px'}}>Ngày tạo {renderDateTime(item?.created)}</p>
			</>
		)},
		{ title: 'Nhân viên', dataIndex: 'user', key: "user", width: '150px', render: (_, item) => (
			item.user?.id &&
			<PopperUserInfo user={item.user}>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item.user?.avatar} /></div>
					<div>
						<b>{item.user?.lastname}</b>
						<p>{item.user?.username}</p>
					</div>
				</div>
			</PopperUserInfo>
		)},
		{title: 'Loại', dataIndex: 'for', key: "for'", render: (_, item) => (renderFor(item?.for))},
		{title: 'Dịch vụ', dataIndex: 'service', key: 'service', render:(_, item) => (
			item?.contract?.id && <Tag color={item?.contract?.service?.badge}>{item?.contract?.service?.label}</Tag>
		)},
		{title: 'Loại dịch vụ', dataIndex: 'serviceType', key: 'serviceType', render:(_, item) => (
			item.contract?.id &&
			<>
				{item.type === 'domain' && <Tag color={item?.contract.service.badge}>{(item.contract.option === 'vn') ? 'Việt Nam' : 'Quốc Tế'}</Tag>}
				{(item.type !== 'domain' && item?.contract?.package) && <Tag color={item?.contract?.service?.badge}>{item?.contract?.package}</Tag>}
			</>
		)},
		{title: 'Đính kèm', dataIndex: 'attach', key: "attach", width: '150px', render: (_, item) => (
			<>
				{(item.attachFileTotal === 0) ? <Tag color="red">Không đính kèm</Tag> : <Tag color="green">Có đính kèm</Tag> }
			</>
		)},
		{title: 'Tình trạng', dataIndex: 'status', key: "status", width: '140px', render: (_, item) => (
			<><Tag color={item.status.badge}>{item.status.label}</Tag></>
		)},
		{title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<BuyServiceAction
				key={`buyService-table-action-${item.id}`}
				item={item}
				setItemEdit={setItemEdit}
				openModal={openModal}
			/>
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default BuyServiceTable;